

























































import Vue from 'vue';
// import buyer, { Buyer } from '@/modules/buyer/buyer';
// import company, { Company } from '@/modules/buyer/company';
// // import * as firebase from '@/plugins/firebase';
// import { firebase } from 'mostra';
import {
  buyer,
  Buyer,
  buyerCompany as company,
  BuyerCompany as Company,
  firebase,
} from 'mostra';

export type DataType = {
  user: Buyer| null;
  company: Company| null;
  loading: boolean;
  isCheckBoxTwoLines: boolean;
}

export default Vue.extend({
  name: 'setting-auth-register',
  data(): DataType {
    return {
      user: null,
      company: null,
      loading: true,
      isCheckBoxTwoLines: true,
    };
  },
  computed: {
    showMessage() {
      if (this.$route.query && this.$route.query.re) {
        return Number(this.$route.query.re) === 1;
      } else {
        return null;
      }
    },
    isRegistered(): boolean {
      if (this.user === null) {
        return false;
      }
      return this.$auth.email === this.user.data.email;
    },
  },
  methods: {
    async save() {
      try {
        this.$loading(true);
        if (this.user && this.company) {
          this.user.data.isCompleted = true;
          await company.save(this.$auth.uid, this.company);
          await buyer.save(this.$auth.uid, this.user);
          await firebase.functions(
            'sendMailOfRegisterAccountForBuyer', {
              to: {
                email: this.user.data.email,
                name: this.user.data.name,
              },
              email: this.user.data.email,
              name: this.user.data.name,
              url: `${window.location.protocol}//${window.location.host}/web/auth/signin`,
              username: this.user.data.name,
            },
          );
          this.$success('登録しました。');
          window.location.href = '/web/buyer/favorites';
        }
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        const uid = this.$auth.uid;
        this.user = await buyer.load(uid);
        this.company = await company.loadByOwner(uid);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    async logout() {
      try {
        await firebase.auth().signOut();
        window.location.href = '/';
      } catch (error: any) {
        this.$fatal(error);
      }
    },
  },
  async mounted() {
    await this.fetchData();
  },
});
